// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-gauge-linear';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.032 4.968v8.136m3.024-8.136v8.136m-5.4-8.136h14.616c.648 0 1.152.504 1.152 1.152v5.832c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V6.12c.072-.648.576-1.152 1.152-1.152z' />
    <path
      fill='currentColor'
      d='M4.032 4.968H1.656c-.576 0-1.08.504-1.152 1.152v5.832c0 .648.504 1.152 1.152 1.152h2.376z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
